<template>
  <div class="linkanalytic-graph-area">
    <template v-for="(dataset, index) in chartData.datasets">
      <div
        :key="index"
        class="checkbox">
        <label>
          <input
            v-model="filteredTypeIds"
            type="checkbox"
            :value="dataset.type_id">
          <div class="option-input"></div>
          <div
            :style="`padding: 0px 5px;
                  background-color: ${dataset.backgroundColor};
                  border: 2px solid ${dataset.borderColor};`">
            {{ dataset.label }}
          </div>
        </label>
      </div>
    </template>
    <div class="linkanalytic-graph-area__content">
      <div class="linkanalytic-header-description">
        ※各項目をクリックすることでグラフを消すことができます。
      </div>
      <div class="">
        <chart
          :height="graphHeight"
          :chart-data="filteredDataCollection"
          :chart-options="chartOption" />
      </div>
      <div class="report-footer-description">
      </div>
    </div>
  </div>
</template>

<script>
import Chart from './Chart'

export default {
  name: 'LinkAnalyticDetailChart',
  components: { Chart },
  props: {
    analyticData: {
      type: Object,
      required: true,
      default: () => ({}),
    },
  },
  data() {
    return {
      filteredTypeIds: [],
      chartData: {},
      chartOption: {
        responsive: true,
        maintainAspectRatio: true,
        scales: {
          yAxes: {
            min: 0,
            ticks: {
              precision: 0,
            },
          },
        },
        legend: {
          display: false,
        },
      },
    }
  },
  computed: {
    graphHeight() {
      return window.innerWidth < 895
        ? window.innerWidth * 0.75
        : 170
    },
    filteredDataCollection() {
      if (!this.chartData || !this.chartData.datasets || !this.filteredTypeIds.length === 0) {
        return {}
      }
      const chartData = { ...this.chartData }
      const { filteredTypeIds } = this
      chartData.datasets = chartData.datasets.filter(
        (dataset) => filteredTypeIds.filter(id => id === dataset.type_id).length > 0,
      )

      return chartData
    },
  },
  watch: {
    analyticData() {
      this.createGraph()
    },
    filteredTypeIds() {
      this.$emit('filtered-type-ids', this.filteredTypeIds)
    },
  },
  methods: {
    async createGraph() {
      if (!this.analyticData
          || !this.analyticData.count
          || (!this.analyticData.count.pv
          && !this.analyticData.count.click)) {
        return
      }
      let labels = this.analyticData.count.pv.map(pv => pv.date)
      const pvDatasets = this.analyticData.count.pv.map(pv => pv.total_count)
      const clickDatasets = this.analyticData.count.click.map(click => click.total_count)

      if (pvDatasets) {
        labels = this.analyticData.count.pv.map(pv => pv.date)
      } else if (clickDatasets) {
        labels = this.analyticData.count.click.map(click => click.date)
      }

      this.chartData = {
        labels,
        datasets: [
          {
            label: 'PV',
            type_id: 1,
            color: 'rgba(252,34,137,1)',
            backgroundColor: 'rgba(252,34,137,0.1)',
            borderColor: 'rgba(252,34,137,0.1)',
            data: pvDatasets,
          },
          {
            label: 'クリック',
            type_id: 2,
            color: 'rgba(34,137,252,1)',
            backgroundColor: 'rgba(34,137,252,0.1)',
            borderColor: 'rgba(34,137,252,1)',
            data: clickDatasets,
          },
        ],
      }
      if (this.filteredTypeIds.length === 0) {
        const typeIds = []
        this.chartData.datasets.forEach((d) => {
          typeIds.push(d.type_id)
        })
        this.filteredTypeIds = typeIds
      }
    },
  },
}

</script>

<style scoped>
.chart-area {
  width:1000px!important;
  height:230px!important;
}
.chart-container {
  position: relative;
  margin: auto;
  width:1000px!important;
  height:230px!important;
}
.c-btn-wrap--with-pager {
}

.single-column {
  width: 200px!important;
  padding: 0 15px;
}
.no-data {
  padding: 50px 0 50px;
}

@media screen and (min-width: 896px) {
  .linkanalytic-header-description {
    font-size: 14px;
    color: #808080;
    text-align: right;
  }
  .linkanalytic-footer-description {
    font-size: 14px;
    color: #808080;
    text-align: right;
  }
}

@media screen and (max-width: 895px) {
  .linkanalytic-header-description {
    font-size: 2.6666666667vw;
    margin: 1.3333333333vw 0 1.3333333333vw;
    text-align: right;
  }
  .linkanalytic-footer-description {
    font-size: 2.6666666667vw;
    margin: 1.3333333333vw 0 1.3333333333vw;
    text-align: right;
  }
}

</style>
